import React, { useEffect } from "react";
import styled from "styled-components";
import ResourcesTabs from "../../../components/AdminCentral/Resources/ResourcesTabs";
import ResourcesList from "../../../components/AdminCentral/Resources/ResourceContent";
import SubtitledVideos from "../../../components/AdminCentral/Resources/SubtitledVideos";
import usePersistentTabState from "../../../hooks/usePersistentTabState";

const breakpoints = {
  tablet: 768,
  phone:  480,
};


const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  min-height: 100vh;
  background-color: transparent;
`;

const Container = styled.div`
  width: 1100px;
  align-items: center;
  padding: 20px;
  // margin: 20px;
  font-family: Arial, sans-serif;
  border-radius: 5px;
  background-color: ${(props) => props.colors.cardBackground}; 
   @media (max-width: ${breakpoints.tablet}px) {
    width: 100%;
    padding: 16px;
  }
  @media (max-width: ${breakpoints.phone}px) {
    width: 350px;
    padding: 12px;
  }
`;

const Title = styled.h1`
  font-size: 36px;
  color: ${({ colors }) => colors.titleText};
  font-weight: 600;
  margin-bottom: 20px;
      @media (max-width: ${breakpoints.phone}px) {
    font-size: 1.5rem;
    text-align: left;
    margin-left: 20px;
    margin-bottom: 16px;
  }
`;

const TABS = ["Resources", "Subtitled Videos"];

const ResourcesPage = ({ colors }) => {
  const [selectedTab, setSelectedTab] = usePersistentTabState(
    "admincentral.resources.selectedTab",
    TABS[0]
  );

  useEffect(() => {
    if (!TABS.includes(selectedTab)) {
      setSelectedTab(TABS[0]);
    }
  }, [selectedTab, setSelectedTab]);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <DashboardContainer>
    <Title colors={colors}> Resources </Title>
    <Container colors={colors}>
      <ResourcesTabs colors={colors} selectedTab={selectedTab} handleTabClick={handleTabClick} />
      {selectedTab === "Resources" && <ResourcesList colors={colors} />}
      {selectedTab === "Subtitled Videos" && <SubtitledVideos colors={colors} />}
    </Container>
    </DashboardContainer>
  );
};

export default ResourcesPage;
